export default __webpack_public_path__ + "static/bf_logo-1d3d76c235e221ea67a89fc91ed2b64c.svg";